import { Content } from 'src/app/models/content';
import { UserVideo } from 'src/app/models/user-video';
import { Trigger } from 'src/app/models/trigger';
import { ContentList } from 'src/app/models/content-list';
import { MessageSimple } from 'src/app/models/message-simple';
import { FormOverlay } from 'src/app/models/form-overlay';

export class Video extends Content{

  type:string = "Video";
  userVideo:UserVideo;
  triggers:Array<Trigger> = [];
  contentLists:Array<ContentList> = [];

  autoplay:boolean = false;

  canvasX:number = 0;
  canvasY:number = 0;

  constructor(object = null){
    super();
    if(object){
      super.set(object);
      this.set(object);
    }
  };

  set(object){
    if(object.userVideo){
      this.userVideo = new UserVideo(object.userVideo);
    }
    if(object.triggers){
      for(let triggerObject of object.triggers){
        let trigger:Trigger = new Trigger(triggerObject);
        this.addTrigger(trigger);
      }
      this.triggers.sort(Trigger.compareSeconds);
    }

    if(object.trigger){
      this.trigger = new Trigger(object.trigger);
      this.trigger.baseContent = this;
    }

    if(object.contentLists){
      for(let contentListObject of object.contentLists){
        let contentList:ContentList = new ContentList(contentListObject);
        this.addContentList(contentList);
      }
    }

    if(object.canvasX){
      this.canvasX = object.canvasX;
    }
    if(object.canvasY){
      this.canvasY = object.canvasY;      
    }
    // this.contentLists.sort(ContentList.comparePartIndex);

    this.mergeLegacyCta();

    this.mergeLegacyForm();
  }

  addTrigger(trigger:Trigger){
    trigger.baseContent = this;
    trigger.setChapterWithUserVideo(this.userVideo);
    this.triggers.push(trigger);
  }

  addContentList(contentList:ContentList){
    contentList.parentVideo = this;
    this.contentLists.push(contentList);
  }

  getContentList(contentListHash:string){
    for(let index in this.contentLists){
      if(this.contentLists[index].hash == contentListHash){
        return this.contentLists[index];
      }
    }
  }
  getContent(contentListHash, contentHash){

    if(contentListHash){
      let contentList = this.getContentList(contentListHash);
      return contentList.getContent(contentHash);  
    }
    else{
      for(let contentList of this.contentLists){
        let content = contentList.getContent(contentHash);
        if(content){
          return content;
        }
      }
    }
  }

  mergeLegacyCta(){
    if(! this.userVideo){
      return;
    }

    if(! this.userVideo.ctaSimple){
      return;
    }

    // Content作成
    const contentObjects = [];
    const contentObject = {
      type:"CtaSimple",
      legacy: true,
      canvasY: 60,
      title: this.userVideo.ctaSimple.title,
      linkUrl: this.userVideo.ctaSimple.linkUrl,
    }
    contentObjects.push(contentObject);

    // ContentList作成
    const contentListObject = {
      type:"ContentList",
      legacy:true,
      contents: contentObjects,
    };
    const contentList = new ContentList(contentListObject);
    contentList.setStartAtContent(contentList.contents[0]);
    this.addContentList(contentList);

    // Trigger作成しtriggersにpush
    const triggerObject = {
      legacy: true,
      nextMainContentHash: this.hash,
      nextSubContentListHash: contentList.hash,
      nextType: "SubContentList",
      videoTriggerType: null,
      videoPosition: null,
      seconds: null,
    };

    triggerObject.videoTriggerType = 'Video';
    triggerObject.videoPosition = 'End';
    triggerObject.seconds = this.userVideo.time;

    let trigger:Trigger = new Trigger(triggerObject);
    this.addTrigger(trigger);
    this.triggers.sort(Trigger.compareSeconds);
  }

  mergeLegacyForm(){
    // formがあればマージ
    if(! this.userVideo){
      return;
    }
    if(! this.userVideo.formOverlay){
      return;
    }

    // Content作成
    const contentObjects = [];
    const contentObject = {
      type:"FormOverlay",
      legacy: true,
      canvasY: 60,
      // formHash: this.userVideo.formOverlay.form.hash,
      hash: this.userVideo.formOverlay.hash,
      form: {
        hash: this.userVideo.formOverlay.form.hash,
        title: this.userVideo.formOverlay.form.title,
        description: this.userVideo.formOverlay.form.description,
        sendBtnTitle: this.userVideo.formOverlay.form.sendBtnTitle,
        sendCompleteType: this.userVideo.formOverlay.form.sendCompleteType,
        sendCompleteTitle: this.userVideo.formOverlay.form.sendCompleteTitle,
        sendCompleteDescription: this.userVideo.formOverlay.form.sendCompleteDescription,
        // overlayWithName: this.userVideo.formOverlay.overlayWithName,
        withSkip: this.userVideo.formOverlay.form.withSkip,
        isVisitorOnly: this.userVideo.formOverlay.form.isVisitorOnly,
        showTiming: this.userVideo.formOverlay.form.showTiming,
        formPropertyKeys: this.userVideo.formOverlay.form.formPropertyKeys,
      }
    };
    contentObjects.push(contentObject);

    // ContentList作成
    const contentListObject = {
      type:"ContentList",
      legacy:true,
      contents: contentObjects,
    };
    const contentList = new ContentList(contentListObject);
    if(! contentList.contents[0]){
      return;
    }
    contentList.setStartAtContent(contentList.contents[0]);
    this.addContentList(contentList);

    const formOverlay = contentList.contents[0] as FormOverlay;

    // complete画面があれば次のComplete時のContentをセット
    if(this.userVideo.formOverlay.form.sendCompleteType == 4){

      const formOverlayCompleteContentObject = {
        legacy: true,
        canvasY: 160,
        title: formOverlay.form.sendCompleteTitle,
        description: formOverlay.form.sendCompleteDescription,
      };
      // CompleteContent
      const formOverlayCompleteContent = new MessageSimple(formOverlayCompleteContentObject);
      formOverlayCompleteContent.parentContentList = contentList;

      // CompleteContentへのtrigger
      const formOverlayCompleteTriggerObject = {
        legacy: true,
        nextMainContentHash: this.hash,
        nextSubContentListHash: contentList.hash,
        nextSubContentHash: formOverlayCompleteContent.hash,
        nextType: "SubContent",
      };
      const formOverlayCompleteTrigger = new Trigger(formOverlayCompleteTriggerObject);
      formOverlay.trigger = formOverlayCompleteTrigger;

      contentList.contents.push(formOverlayCompleteContent);
    }

    // Trigger作成しtriggersにpush
    const triggerObject = {
      legacy: true,
      nextMainContentHash: this.hash,
      nextSubContentListHash: contentList.hash,
      nextType: "SubContentList",
      videoTriggerType: null,
      videoPosition: null,
      seconds: null,
    };

    // ShowTiming
    switch(formOverlay.form.showTiming){
      case 'first':
        triggerObject.videoTriggerType = 'Video';
        triggerObject.videoPosition = 'Start';

        // フォームのshowTimingがfirstかつliveの場合に、フォームのトリガーのstart時刻にアクセス時の時間を設定する。
        // そうすることでライブ配信前に訪問してもクリック押下時にフォームを先に表示でき、UXを改善できる。
        if(this.userVideo.live){
          // 現在時刻
          const currentTime = Math.floor((new Date()).getTime() / 1000);

          // 開始時刻からの差分
          const diffTimeFromStart = currentTime - this.userVideo.live.start;
          triggerObject.seconds = diffTimeFromStart;
        }
        break;
      case 'last':
        triggerObject.videoTriggerType = 'Video';
        triggerObject.videoPosition = 'End';
        triggerObject.seconds = this.userVideo.time;
        break;
      default:
        triggerObject.videoTriggerType = 'Seconds';
        triggerObject.seconds = formOverlay.form.showTiming;
        break;
    }

    let trigger:Trigger = new Trigger(triggerObject);
    this.addTrigger(trigger);
    this.triggers.sort(Trigger.compareSeconds);
  }  
}
  
  